import React from "react";

const VerticalProgressBar = ({usedMoneyValue,gradientPercentage,limit}) => {
  const fillerStyles = {
    background:
      "linear-gradient(109.08deg, #2965FB 12.11%, #4B70B9 57.56%, #30BC89 102.11%)",
    position: "absolute",
    bottom: 0,
    height: gradientPercentage, 
    width: "100%",
  };

  const containerStyles = {
    height: "170px", // example: 170px
    width: "125px", // example: 125px
    backgroundColor: "#324261",
    borderRadius: "10px",
    position: "relative",
    overflow: "hidden", 
  };

  return (
    <>
      <div className="flex gap-[22px] justify-center">
        <div className="flex flex-col justify-between py-[15px]">
          <div className="font-hanken-grotesk  text-[#779CE5] text-[16px]">Limit</div>
          <div className="font-hanken-grotesk text-[16px] text-[#FFFFFF]">Used</div>
        </div>
        <div style={containerStyles}>
          <div style={fillerStyles}></div>
        </div>
        <div className="flex flex-col justify-between py-[15px]">
          <div className= "font-hanken-grotesk text-[#779CE5] text-[16px]">${limit}</div>
          <div className="font-hanken-grotesk text-[16px] text-[#FFFFFF]">{usedMoneyValue}</div>
        </div>
      </div>
    </>
  );
};

export default VerticalProgressBar;
